// score-modal.component.ts
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, FormGroup, FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ScoreService } from '../../../services/scores.service';

@Component({
    selector: 'app-custom-slider',
    templateUrl: './custom-slider.component.html',
    styleUrls: ['./custom-slider.component.css']
})
export class CustomSliderComponent  implements OnInit, AfterViewInit {
    @Input() sliderType: string;
    @Input() value: number | null = null;
    @Input() min: number = 0;
    @Input() max: number = 20;
    @Input() noScoreValue: number = this.min - 1; // default to min - 1 for no score
    @Input() readOnly: boolean = false;
    @Input() trackColor: string = '#DA6E1D'; // Default color
    @Input() thumbHidden: boolean = false;

    //@Output() valueChange: EventEmitter<number> = new EventEmitter<number>();
    @Output() valueChange = new EventEmitter<number | null>();

    sliderBarColor: string = this.trackColor;
    private isDragging: boolean = false;

    // Color map representing the DB values for slider types
    private colorMap: { [key: string]: string } = {
        0: '#E53935',   // Red
        5: '#FB8C00',   // Orange
        10: '#FDD835',  // Yellow
        15: '#7CB342',  // Green
        20: '#388E3C'   // Dark Green
    };

    private offsets: number[] = [
        -1.6, 2.7, 2.5, 2.2, 2.0, 1.8, 1.4, 1.0, 0.9, 0.6, 0.4,
        0,
        -0.4, -0.6, -0.9, -1.0, -1.4, -1.8, -2.0, -2.2, -2.5, -2.7
    ];

    constructor(
        //public activeModal: NgbActiveModal,
        private fb: UntypedFormBuilder,
        private scoreService: ScoreService
    ) { }

    ngOnInit(): void {
        this.scoreService.loadAllScoreColors().subscribe(() => {
            this.updateSliderColor();
        });
    }

    ngAfterViewInit(): void {

    }

    onSliderChange(event: any): void {
        //this.value = event.target.value;
        //this.valueChange.emit(this.value);

        this.value = +event.target.value === this.noScoreValue ? null : +event.target.value;
        this.valueChange.emit(this.value);
        this.updateSliderColor();
        this.valueChange.emit(this.value);
    }

    onChange(event: any) {
        this.valueChange.emit(this.value);
    }

    getThumbPosition(): number {
        var offset: number;
        if (this.value === null) {
            offset = this.calculateOffset(0); // Position for no score
        }
        else {
            offset = this.calculateOffset(this.value + 1);
        }
        const position = ((this.value - this.noScoreValue) / (this.max - this.noScoreValue)) * 100;
        //const offset = 0;
        const correctedPosition = position + offset;
        return correctedPosition;
    }

    /** Calculates thumb position */
    //getThumbPosition(): number {
    //    const range = this.max - this.noScoreValue;
    //    return ((this.value ?? this.noScoreValue) - this.noScoreValue) / range * 100;
    //}

    /** Handles thumb dragging */
    startDrag(event: MouseEvent): void {
        if (this.readOnly) return;
        event.preventDefault();
        this.isDragging = true;
        document.addEventListener('mousemove', this.onDrag.bind(this));
        document.addEventListener('mouseup', this.stopDrag.bind(this));
    }

    /** Handles dragging event */
    onDrag(event: MouseEvent): void {
        if (!this.isDragging) return;

        const slider = event.target as HTMLElement;
        const rect = slider.parentElement.getBoundingClientRect();
        let newValue = Math.round(((event.clientX - rect.left) / rect.width) * (this.max - this.min) + this.min);

        // Clamp value to min/max
        newValue = Math.max(this.min, Math.min(this.max, newValue));
        this.value = newValue;
        this.updateSliderColor();
        this.valueChange.emit(this.value);
    }

    /** Stops dragging */
    stopDrag(): void {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
    }

    calculateOffset(value: number): number {
        // Use a polynomial function or any other formula to dynamically calculate the offset
        // Adjust the coefficients as needed
        //return -0.0005 * Math.pow(value, 2) + 0.1 * value;
        //const a = -0.027;  // Approximated coefficient for the quadratic term
        //const b = 0.01;    // Approximated coefficient for the linear term
        //const offset = a * Math.pow(value - 10, 2) + b * (value - 10);
        //return offset;


        return this.offsets[value] || 0;
    }

    // Dynamically set the slider bar color based on the value
    private updateSliderColor(): void {
        if (this.readOnly) {
            this.sliderBarColor = this.trackColor;
            return;
        }
        const scoreType = this.sliderType.toLowerCase();
        const value = this.value ?? this.min;

        this.sliderBarColor = this.scoreService.getColorForScore(scoreType, value);
    }

}
